import { ThreediModel } from "@nens/threedi/openapi-client";

// The model is generated asynchronously; isValid stays null/undefined while that's in progress.
export const modelIsBeingGenerated = (
  model: ThreediModel | null | undefined
): model is ThreediModel => !!model && model.isValid !== true && model.isValid !== false;
